import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useLoading } from "../contexts/LoadingContext";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import { PaymentInquiry } from "./inquire-payment";
import "./package-screen.css";
//  <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       backdrop="static"
//       dialogClassName="terms-modal"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Terms And Conditions</Modal.Title>
//       </Modal.Header>

//       <Modal.Body className="p-0 terms-body">
//         <iframe
//           src="/mobile-insurance.pdf"
//           title="Terms PDF"
//           className="terms-iframe"
//         />
//       </Modal.Body>

//       <Modal.Footer>
//         <Button variant="secondary" onClick={handleClose}>
//           Ok
//         </Button>
//       </Modal.Footer>
//     </Modal>
// const CenteredModal = ({ show, handleClose, terms }) => {
//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       className="p-3"
//       backdrop="static"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Terms And Conditions</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div dangerouslySetInnerHTML={{ __html: terms }} />
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={handleClose}>
//           Ok
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };
const CenteredModal = ({ show, handleClose, title }) => {
  const BASE_URL = "https://webdoc.com.pk/assets/documents/";
  const TERMS_MAP = {
    "Third Party Car": "Third-party-car.pdf",
    "Monthly Mobile": "Mobile-Insurance.pdf",
    "Monthly Bike": "Bike-Insurance.pdf",
  };

  // fallback if not found
  const fileName = TERMS_MAP[title] || "default.pdf";

  const fileUrl = `${BASE_URL}${fileName}`;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      dialogClassName="terms-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms And Conditions</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0 terms-body">
        <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
            fileUrl,
          )}`}
          className="terms-iframe"
          title="Terms PDF"
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const PackageScreen = ({ items, terms, title }) => {
  const navigate = useNavigate();
  const { isLoading, setIsLoading } = useLoading();
  const [selectedOption, setSelectedOption] = useState(items[0]);
  const [description, setDescription] = useState(
    items.length > 0 ? items[0].description : "",
  );
  const [coverage, setCoverage] = useState(
    items.length > 0 ? items[0].coverage : "",
  );

  const [cnic, setCnic] = useState("");
  const [registrationNo, setRegistrationNo] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleButtonClick = (item) => {
    setSelectedOption(item);
    setDescription(item.description);
    setCoverage(item.coverage);
  };

  // const byClickingBuyPackage = useCallback(
  //   (id, price, type, apiKey, coverage) => {
  //     setIsLoading(true);
  //     const item = sessionStorage.getItem("user");
  //     const sess = JSON.parse(item);

  //     const form = new FormData();
  //     form.append("value", Number(price) * 100);

  //     if (apiKey === "") {
  //     } else {
  //       form.append("apikey", apiKey);
  //     }
  //     const settings = {
  //       method: "POST",
  //       body: form,
  //     };

  //     fetch(
  //       `https://miniappeasypaisa.webddocsystems.com/public/api/v1/create-payment`,
  //       settings
  //     )
  //       .then((response) => response.json())
  //       .then((result) => {
  //         console.log(result);

  //         if (result.paymentTransactionID) {
  //           setIsLoading(false);
  //           if (type === "calladoc") {
  //             sess["package"] = "true";
  //             const updatedItem = JSON.stringify(sess);
  //             sessionStorage.setItem("user", updatedItem);
  //           }
  //           // if payment issue then commit this like and then check on browser
  //           window.mp.createPayment(result.paymentTransactionID);
  //         }
  //       })
  //       .catch((error) => {
  //         setIsLoading(false);
  //         console.error("Error:", error);
  //       });

  //     // if payment issue then comment this line and then check on browser
  //     // =====>
  //     window.createPaymentResult = (jsonResult) => {
  //       const result = JSON.parse(jsonResult);
  //       alert(jsonResult);
  //       // isLoading(true)
  //       navigate(`/confirm`, {
  //         state: {
  //           type,
  //           price,
  //           coverage: coverage,
  //           pid: id,
  //           status: result.paymentStatus,
  //           code: result.resultCode,
  //           tid: result.paymentTransactionID,
  //         },
  //       });
  //     };

  //     // =====>
  //     // if payment issue then uncomment this line and then check on browser

  //     // navigate(`/confirm`, {
  //     //   state: {
  //     //     type,
  //     //     price,
  //     //     coverage: coverage,
  //     //     pid: id,
  //     //     status: "S",
  //     //     code: "SUCCESS",
  //     //     tid: "1123123",
  //     //   },
  //     // });
  //   },
  //   []
  // );
  const byClickingBuyPackage = useCallback(
    async (id, price, type, apiKey, coverage, cnic, registrationNo) => {
      // if (id == 1248) {
      // navigate(`/confirm`, {
      //   state: {
      //     apiKey,
      //     type,
      //     price,
      //     cnic,
      //     registrationNo,
      //     coverage: coverage,
      //     pid: id,
      //     status: "S",
      //     code: "SUCCESS",
      //     tid: "1123123",
      //   },
      // });
      // return;
      // }
      try {
        setIsLoading(true);

        // Fetch user data from sessionStorage only once
        const item = sessionStorage.getItem("user");
        const sess = item ? JSON.parse(item) : {};

        const form = new FormData();
        form.append("value", Number(price));
        if (apiKey) {
          // alert(JSON.stringify(apiKey));
          form.append("apikey", apiKey);
        }

        // Make the API call
        const response = await fetch(
          // `https://7c5c-124-109-46-74.ngrok-free.app/ci4easypaisa/public/api/v1/create-payment`,
          `https://miniappeasypaisa.webddocsystems.com/public/api/v1/create-payment`,
          {
            method: "POST",
            body: form,
          },
        );

        const result = await response.json();
        // alert(JSON.stringify({ log: "createPayment Api", data: result }));

        if (result.paymentTransactionID) {
          // Proceed to Payment Inquiry
          // navigate(`/confirm`, {
          //   state: {
          //     apikey: apiKey || "Bike",
          //     type,
          //     price,
          //     coverage,
          //     pid: id,
          //     status: result.paymentStatus || "S", // Default status to "S" if missing
          //     code: result.resultCode || "SUCCESS", // Default code to "SUCCESS" if missing
          //     tid: result.paymentTransactionID || "1123123", // Fallback transaction ID
          //   },
          // });
          // Update session storage if needed
          if (type === "calladoc") {
            sess["package"] = "true";
            sessionStorage.setItem("user", JSON.stringify(sess));
          }

          // Handle payment result
          window.mp.createPayment(result.paymentTransactionID);
        }
      } catch (error) {
        setIsLoading(false);
        console.log("Error:", error);
      } finally {
        setIsLoading(false);
      }

      // Set payment result handler
      window.createPaymentResult = (jsonResult) => {
        const result = JSON.parse(jsonResult);
        // alert(
        //   JSON.stringify({ log: "window.createPaymentResult", data: result }),
        // );
        navigate(`/confirm`, {
          state: {
            apiKey,
            type,
            price,
            cnic,
            registrationNo,
            coverage,
            pid: id,
            status: result.paymentStatus || "S", // Default status to "S" if missing
            code: result.resultCode || "SUCCESS", // Default code to "SUCCESS" if missing
            tid: result.paymentTransactionID || "1123123", // Fallback transaction ID
          },
        });
      };
    },
    [],
  );

  useEffect(() => {
    const redirectFromPaymentFailed = sessionStorage.getItem(
      "redirectFromPaymentFailed",
    );

    if (redirectFromPaymentFailed === "true") {
      Swal.fire({
        icon: "error",
        title: "Payment Failed",
        text: "Something went wrong please try again.",
        confirmButtonText: "Ok",
      }).then(() => {
        sessionStorage.removeItem("redirectFromPaymentFailed");
      });
    }
  }, []);

  const handlePayNowClick = () => {
    console.log("Selected Option:", selectedOption);
    const { id, price, type, apiKey } = selectedOption;

    byClickingBuyPackage(
      id,
      parseInt(price),
      type,
      apiKey,
      coverage,
      cnic,
      registrationNo,
    );
  };

  return (
    <div className="container">
      <div style={{ marginBottom: "125px" }}>
        <div className="row mt-2 position-relative">
          <div className="col-12">
            <p className="custome-textfont fw-bold mt-2 mb-1">
              Select price point to subscribe the service
            </p>
          </div>
          <div className="col-12">
            <div className="card">
              <div className="row d-flex justify-content-center">
                <div className="col-md-12 col-12 text-center mb-1 p-2">
                  <div className="packages_list">
                    {items.map((item, index) => (
                      <div className="" key={index}>
                        <Button
                          variant={
                            selectedOption.id === item.id
                              ? "light"
                              : "outline-light"
                          }
                          className="w-100 p-2 py-3 d-flex text-dark align-items-center border-0 border-bottom rounded-0 bg__active"
                          onClick={() => handleButtonClick(item)}
                        >
                          <div className="grow text-start">
                            <div className="d-flex align-items-baseline">
                              <p
                                className="mb-0 fw-bold"
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "500",
                                  fontFamily: "Arial, sans-serif",
                                }}
                              >
                                {item.isfree ? (
                                  <>
                                    <span className="badge bg-success">
                                      Free
                                    </span>
                                  </>
                                ) : (
                                  <span>
                                    Rs. {Number(item.price).toLocaleString()}
                                  </span>
                                )}
                              </p>
                              <p
                                className="mb-0 text-secondary ms-2"
                                style={{ fontSize: "12px" }}
                              >
                                {item.badge}
                              </p>
                            </div>
                          </div>
                          <div className="shrink-0 me-2">
                            <div
                              className={`package_radio ${
                                selectedOption.id === item.id
                                  ? "package_radio_active"
                                  : ""
                              }`}
                            ></div>
                          </div>
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <hr />
                </div>
              </div>
              {coverage !== "-" && (
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex flex-column">
                      <p className="packages_list p-3 fs-15">
                        Coverage:
                        <strong
                          className="float-end"
                          style={{ fontSize: "15px" }}
                        >
                          {selectedOption.apiKey === "ThirdPartyCar" && (
                            <span
                              style={{
                                fontWeight: "lighter",
                                marginRight: 4,
                                fontSize: "12px",
                              }}
                            >
                              upto
                            </span>
                          )}
                          Rs. {Number(coverage).toLocaleString()}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-12">
                  <p
                    id="description"
                    className="custome-textfont"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></p>
                </div>
              </div>
            </div>
            {title === "Third Party Car" && (
              <div className="flex flex-col gap-3 mb-2">
                <input
                  type="text"
                  id="cnic"
                  placeholder="Enter CNIC"
                  value={cnic}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // remove non-numeric
                    if (value.length <= 13) {
                      setCnic(value);
                    }
                  }}
                  className="border border-green-600! p-2 rounded  focus:outline-green-400"
                />

                <input
                  type="text"
                  id="registration"
                  placeholder="Enter Registration No"
                  value={registrationNo}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // alphanumeric only
                    if (value.length <= 7) {
                      setRegistrationNo(value.toUpperCase());
                    }
                  }}
                  className="border border-green-600! p-2 rounded  focus:outline-green-400"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="fixed-bottom-center p-2 py-1">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <small className="text-start">
                <input
                  type="checkbox"
                  checked={isChecked}
                  className="form-check-input terms_checkbox me-2"
                  onChange={(e) => setIsChecked(e.target.checked)}
                />{" "}
                By tapping{" "}
                <strong style={{ color: "#1bb367" }}>"Pay Now"</strong> you are
                accepting our{" "}
                <span
                  onClick={handleShow}
                  role="button"
                  className="text-decoration-none"
                  style={{ color: "#2240F4", cursor: "pointer" }}
                >
                  Terms & Conditions
                </span>
              </small>

              <button
                className="btn btn-success w-100 p-2 rounded-pill border-0"
                onClick={handlePayNowClick}
                disabled={
                  !isChecked ||
                  (title === "Third Party Car" && (!cnic || !registrationNo))
                }
                style={{ backgroundColor: "#1bb367" }}
              >
                Pay Now
              </button>
              <div className="d-flex justify-content-end align-items-end mt-1">
                <p className="custome-textfont mb-0 text-end me-1 text-secondary">
                  Powered By
                </p>
                <img
                  src="/assets/NewMiniapp/powerd-by-log.png"
                  alt="Logo"
                  className="img-fluid"
                  width={40}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CenteredModal show={show} handleClose={handleClose} title={title} />
    </div>
  );
};

export default PackageScreen;
